import React from 'react';
import { Link } from 'react-router-dom';

const PreorderCustomPolicy = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <div className="bg-white shadow rounded-lg p-8">
          <div className="mb-8">
            <h1 className="text-3xl font-bold text-gray-900 mb-4">Preorder & Custom/Made-to-Order Policy</h1>
            <Link
              to="/legal"
              className="text-blue-600 hover:text-blue-500 font-medium"
            >
              ← Back to Legal Center
            </Link>
          </div>

          <div className="prose max-w-none">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">1. Lead Time Requirements</h2>
            <p className="text-gray-700 mb-6">
              Sellers must clearly communicate lead times for custom orders. Standard lead times range from 
              24 hours to 2 weeks depending on complexity. Rush orders may incur additional fees. All 
              delivery dates must be realistic and achievable.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mb-4">2. Deposit Requirements</h2>
            <p className="text-gray-700 mb-6">
              Custom orders require a 25-50% deposit at the time of booking. Deposits are non-refundable 
              unless the seller fails to deliver as agreed. The remaining balance is due upon delivery 
              or pickup.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mb-4">3. Cancellation Policy</h2>
            <p className="text-gray-700 mb-6">
              Cancellations must be made at least 48 hours before the scheduled delivery/pickup time for 
              full refund of the deposit. Cancellations within 48 hours may result in partial or no refund 
              depending on preparation progress.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mb-4">4. Force Majeure Clauses</h2>
            <p className="text-gray-700 mb-6">
              In cases of extreme weather, natural disasters, illness, or other unforeseen circumstances, 
              both parties may be excused from their obligations. Vesta will work with all parties to 
              find fair resolutions, including rescheduling or full refunds.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mb-4">5. Customization Limits</h2>
            <p className="text-gray-700 mb-6">
              Sellers may set reasonable limits on customizations based on their capabilities and equipment. 
              Complex requests may require additional consultation and may affect pricing and lead times.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mb-4">6. Quality Assurance</h2>
            <p className="text-gray-700 mb-6">
              Custom orders must meet the same quality standards as regular menu items. Sellers should 
              provide samples or photos when possible to ensure customer satisfaction. Any quality issues 
              must be addressed promptly.
            </p>

            <div className="mt-8 pt-6 border-t border-gray-200">
              <p className="text-sm text-gray-500">
                Last updated: {new Date().toLocaleDateString()}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PreorderCustomPolicy; 